import { fetchApi } from "../../tools";

const getPedidos = async (props) => {
  const { headers, idProveedor, urlInvoiceApi } = props;
  const res = await fetchApi({
    url: urlInvoiceApi + "/utils/busquedas",
    headers,
    content: {
      opcion: "PEDIDOSPROVEEDORES",
      IdProveedor: idProveedor,
    },
  });
  return res.msg;
};

const getCajasChicas = async (props) => {
  const { headers, idPeriodo, urlSchoolApi, Revisar } = props;
  const res = await fetchApi({
    url: urlSchoolApi + "/utils/busquedas",
    headers,
    content: {
      opcion: "CAJA_CHICA",
      IdPeriodo: idPeriodo,
      RevisarCaja: Revisar,
    },
  });
  return res.msg;
};

const getRevisionFacturas = async (props) => {
  const { headers, urlInvoiceApi } = props;
  const res = await fetchApi({
    url: urlInvoiceApi + "/utils/busquedas",
    headers,
    content: {
      opcion: "REVISIONFACTURAS",
    },
  });
  return res.msg;
};

const enviar = async (arrEnvios, headers, urlInvoiceApi) => {
  let arr = [];
  for await (const element of arrEnvios) {
    let res = await fetchApi({
      url: urlInvoiceApi + "/proveedores/envios_proveedores",
      method: "POST",
      headers: headers,
      content: element,
    });
    arr.push(res.msg[0]["Error"]);
  }
  return arr;
};
/*
      POST
    /schoolapi/finanzas/revisacajachica
    {
      "IdPeriodo": "202409",
      "Detalle": {
        "Detalle": [
          {
            "Id": 29
          }
        ]
      },
      "IdEmp": "MMORALE149",
      "HostName": "DEV07",
      "IpHost": "131.107.1.235",
      "OS": "Windows"
    }
  */
const enviarCajas = async (content, headers, urlSchoolApi) => {
  let res = await fetchApi({
    url: urlSchoolApi + "/finanzas/revisacajachica",
    method: "POST",
    headers,
    content,
  });

  return res;
};

export { enviar, getPedidos, enviarCajas, getRevisionFacturas, getCajasChicas };

